import clsx from 'clsx';
import { Pagination } from '../../../../../shared/ui/pagination/Pagination';
import { Select } from '../../../../../shared/ui/select/Select';
import styles from '../TemplatesList.module.css';

export function TemplatesPaginationRow({
  itemsLength,
  page,
  pageSize,
  totalPages,
  onPageChange,
  onPageSizeChange,
}) {
  if (itemsLength <= 0) return null;

  return (
    <div className={clsx(styles.paginationRow)} aria-label="Pagination">
      {totalPages > 1 ? (
        <Pagination page={page} totalPages={totalPages} onPageChange={onPageChange} />
      ) : (
        <div />
      )}
      <div className={clsx(styles.itemsPerPage)}>
        <span className={clsx(styles.itemsPerPageLabel)}>Items per page</span>
        <div className={clsx(styles.itemsPerPageField)}>
          <Select
            value={pageSize}
            aria-label="Items per page"
            menuPlacement="top"
            options={[
              { value: 15, label: '15' },
              { value: 30, label: '30' },
              { value: 60, label: '60' },
            ]}
            onChange={(next) => onPageSizeChange?.(Number(next))}
          />
        </div>
      </div>
    </div>
  );
}
